{
  "units": {
    "kg": "kg",
    "each": "each",
    "metre": "m",
    "litre": "L"
  },
  "storageClass": {
    "detonator": "Detonator",
    "highExplosive": "High explosive",
    "blastingAgent": "Blasting agent",
    "oxidiser": "Oxidiser",
    "nonHazardous": "Non-hazardous",
    "stemming": "Stemming"
  },
  "storeKind": {
    "detonatorMagazine": "Detonator magazine",
    "explosivesMagazine": "Explosives magazine",
    "bulkPrecursorStore": "Bulk precursor store",
    "mmu": "MMU",
    "quarantine": "Quarantine"
  },
  "licence": {
    "shotfirer": "Shotfirer",
    "dpimBlastController": "Blast controller (DPIM)",
    "magazineKeeper": "Magazine keeper",
    "explosivesTransport": "Explosives transport",
    "drillOperator": "Drill operator"
  },
  "movement": {
    "receipt": "Receipt",
    "issueToBlast": "Issue to blast",
    "returnFromBlast": "Return from blast",
    "transfer": "Transfer",
    "destruction": "Destruction",
    "adjustment": "Adjustment",
    "stocktake": "Stocktake",
    "reversal": "Reversal"
  },
  "ownership": {
    "mine": "Mine",
    "consignment": "Consignment",
    "mineOwned": "Mine owned",
    "supplierConsignment": "Supplier consignment"
  },
  "shared": {
    "magazine": "Magazine",
    "lot": "Lot {{lot}}",
    "noLot": "No lot"
  },
  "magazineRegister": "Magazine register",
  "register": {
    "deliveredTitle": "Delivered down the hole",
    "deliveredIntro": "What was charged into holes, by supplier and product, for blasts fired in the period. It is the check figure for the supplier's invoice and, for consignment stock, when ownership passes to the mine.",
    "from": "From",
    "to": "To",
    "supplier": "Supplier",
    "notRecorded": "Not recorded",
    "product": "Product",
    "downTheHole": "Down the hole",
    "valueAtStandardCost": "Value at standard cost",
    "blasts": "Blasts"
  },
  "registerModal": {
    "subject": "Register",
    "day": "Day"
  },
  "store": {
    "licence": "Licence {{number}}",
    "heldAgainstLicence": "Held against licence",
    "neqHeld": "{{held}} / {{licensed}} kg NEQ",
    "empty": "Empty",
    "expires": "Expires {{date}}",
    "pendingStocktake": "Stocktake variance waiting for approval",
    "parkedMovements_one": "{{count}} offline movement needs resolving",
    "parkedMovements_other": "{{count}} offline movements need resolving",
    "reverseExplanation": "The register keeps the original and adds a reversing entry that puts every quantity back where it came from. Both appear on the register with your reason.",
    "movement": "Movement",
    "waitingForAdmin": "Waiting for an admin",
    "discarded": "Discarded",
    "enteredLate": "Entered late",
    "reversed": "Reversed",
    "products": "Products",
    "fromTo": "From / to",
    "blast": "Blast",
    "person": "Person",
    "reference": "Reference",
    "reverse": "Reverse",
    "register": "Register",
    "stocktake": "Stocktake",
    "queued_one": "{{count}} movement is saved on this device, waiting for a connection to reach the register.",
    "queued_other": "{{count}} movements are saved on this device, waiting for a connection to reach the register.",
    "noMagazines": "No magazines yet. An admin adds them on the Magazines page.",
    "movementsOn": "Movements on {{date}}",
    "neverEdited": "Movements are never edited or deleted. A mistake is corrected by reversing it, which keeps both entries on the register."
  },
  "movementForm": {
    "noShotfirerLicence": "no shotfirer licence",
    "lotLeft": "{{quantity}} {{unit}} left",
    "lotExpires": "expires {{date}}",
    "theStore": "The store",
    "thatProduct": "that product",
    "shortfall": "{{store}} held {{quantity}} {{unit}} of {{material}} in that lot when this device last had a connection.",
    "waitsForAdmin": "If the register agrees when this syncs, the movement waits for an admin instead of going on the register.",
    "queued": "No connection, so the {{movement}} is saved on this device. It goes on the register when the connection is back.",
    "queuedWithShortfalls": "No connection, so the {{movement}} is saved on this device. It goes on the register when the connection is back. {{shortfalls}} If the register agrees, it will wait for an admin.",
    "recorded": "{{movement}} recorded",
    "when": "When",
    "destroyedOnBench": "Destroyed on the bench, from a blast's issue",
    "from": "From",
    "into": "Into",
    "blast": "Blast",
    "issuedTo": "Issued to",
    "returnedBy": "Returned by",
    "witness": "Witness",
    "deliveryDocket": "Delivery docket",
    "destructionCertificate": "Destruction certificate",
    "reference": "Reference",
    "product": "Product",
    "lot": "Lot",
    "expires": "Expires",
    "quantityIn": "Quantity ({{unit}})",
    "quantity": "Quantity",
    "remove": "Remove",
    "addProduct": "Add a product",
    "notes": "Notes",
    "recordAnywayQuestion": "Record it anyway?",
    "recordAnyway": "Record anyway",
    "record": "Record"
  },
  "stocktakeForm": {
    "agrees": "Count agrees with the register",
    "waitingForApproval": "Count recorded; the differences are waiting for an admin to approve",
    "recorded": "Count recorded",
    "title": "Stocktake",
    "intro": "Count what is in the magazine. The register's figures are not shown, so the count stays independent; any difference goes to an admin to approve before the register changes.",
    "sheetNumber": "Count sheet number",
    "nothingHeld": "The register holds nothing in this magazine.",
    "packsOf": "Packs of {{size}}",
    "loose": "Loose ({{unit}})",
    "counted": "Counted ({{unit}})",
    "submit": "Submit count"
  },
  "parked": {
    "intro": "These were recorded without a connection, and when they synced the register could not take them as they stood. They are not on the register until they are posted.",
    "explainPost": "It goes on the register at {{at}}, when it happened. Post it once the store's balance accounts for it, usually after a stocktake or a late delivery has been recorded."
  },
  "pendingStocktakes": {
    "book": "register",
    "setAside": "Set aside",
    "approveTitle": "Approve the stocktake",
    "setAsideTitle": "Set the stocktake aside",
    "approveExplain": "The register for {{magazine}} will be adjusted to the count. Your comment is kept with the adjustment.",
    "setAsideExplain": "The count for {{magazine}} will be kept but the register will not change. Ask for a recount if the difference is real.",
    "approved": "Stocktake approved and posted",
    "setAsideDone": "Stocktake set aside"
  },
  "magazines": {
    "kind": "Kind",
    "runBy": "Run by",
    "ownership": "Ownership",
    "licence": "Licence",
    "licensedNeq": "Licensed NEQ (kg)",
    "retired": "Retired",
    "add": "Add a magazine"
  },
  "magazineForm": {
    "saved": "Magazine saved",
    "editTitle": "Edit {{name}}",
    "runByZone": "Run by zone",
    "licenceNumber": "Licence number",
    "licenceExpires": "Licence expires",
    "inUse": "In use",
    "mayHold": "May hold (leave all clear for the usual classes for its kind)"
  }
}
